var _path, _polygon, _path2, _polygon2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _circle2, _path9, _rect, _rect2, _rect3, _path10, _path11, _rect4, _rect5, _rect6, _circle3, _circle4, _circle5, _rect7, _rect8, _rect9, _rect10, _rect11, _polygon3, _polygon4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle6, _path22, _rect12, _rect13, _rect14, _circle7, _path23, _rect15, _rect16, _rect17, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eab74653-e4ff-4b0f-8495-b71ce9943559",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 899.86614,
    height: 731.19068,
    viewBox: "0 0 899.86614 731.19068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.49731,547.15369a10.05574,10.05574,0,0,1-5.12556-14.5425l-23.07542-27.2856,18.43836-2.20463,19.086,26.24886a10.11028,10.11028,0,0,1-9.32339,17.78387Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "161.428 718.482 173.687 718.481 179.52 671.193 161.425 671.194 161.428 718.482",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.36722,798.88372l3.4508-.00013,13.47243-5.47893,7.22081,5.47809h.001A15.38731,15.38731,0,0,1,347.89872,814.269v.5l-39.53077.00146Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.937 710.756 220.896 713.456 237.001 668.614 219.351 664.629 208.937 710.756",
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.835,790.56746l3.36606.76,14.3484-2.37667,5.83675,6.93412.00095.00021a15.3873,15.3873,0,0,1,11.61929,18.39761l-.11014.48771-38.56009-8.70633Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.05029,559.64482l11.08632,124.20931s-4.15391,74.56955,9.25,100.81h19.4393l9.6247-107.62,1.20861-72.23521L381.335,665.75111,354.79045,782.90466l23.9252,2.13884,43.0748-127.13884L374.46727,538.55115Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.59421,
    cy: 248.84861,
    r: 28.59081,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.68185,389.0897,327.466,379.02561l-4.32255-13.29253-35.62041,5.78181-7.56821,12.9766-24.49947,22.78084L284.15933,537.0582l-.86888,28.34646s18.3713,8.27056,98.04459-10.77166c.95541-.22834-1.04459-1.22834-1.04459-1.22834Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392.22648,532.15466,353.29,480.015l-11.03833-92.40576.322-.15528a20.18152,20.18152,0,0,1,28.91992,17.373l2.29517,57.10108,38.67041,51.03125Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.93107,349.47631q-.29881-.40778-.59179-.82245c-.07862.166-.14112.33753-.231.49964Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M329.10148,312.34027a18.24293,18.24293,0,0,0-9.54541-9.2215,17.41677,17.41677,0,0,0-13.0581.01141c-3.77979-2.38806-7.97949-4.28125-12.40235-4.51574s-9.09912,1.40637-11.8247,5.01831a19.30233,19.30233,0,0,1-2.06592,2.6839c-2.19092,2.02893-5.52051,1.73626-8.43262,1.32141q1.95923,1.67916,3.91944,3.35833-2.37159.61955-4.74366,1.23914,2.76783,1.67862,5.53516,3.35724c-5.35645,3.215-7.791,10.2323-7.14795,16.60547.6084,6.03387,3.52149,11.55145,7.00391,16.45562,1.38916-2.93151,1.08984-6.43927,1.06689-9.741-.02392-3.48859.59326-7.45,3.38867-9.39972,1.88575-1.31519,4.31055-1.3739,6.58448-1.36145a302.50731,302.50731,0,0,1,34.3164,2.14233,9.66022,9.66022,0,0,1,4.39356,1.27429c2.51855,1.7182,3.00927,5.264,3.2622,8.37482a60.68186,60.68186,0,0,0,1.937-15.73083A28.995,28.995,0,0,0,329.10148,312.34027Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.22352,
    cy: 530,
    r: 45,
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.29045,568.40466a46.24694,46.24694,0,0,0-6.91016.52c-1.16992.17-2.30957.38995-3.43994.66a45.97706,45.97706,0,0,0-19.48974,79.8c.77.65,1.5498,1.28,2.35986,1.88a45.99007,45.99007,0,1,0,27.48-82.86Zm0,90a43.74633,43.74633,0,0,1-26-8.53c-.81983-.6-1.60986-1.22-2.37988-1.88a43.974,43.974,0,0,1,19.62011-76.71c1.11963-.23,2.23975-.41,3.37989-.55a43.52969,43.52969,0,0,1,5.37988-.33,44,44,0,1,1,0,88Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 301.29045,
    y: 599.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(502.51397 1120.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 301.29045,
    y: 611.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(502.51397 1144.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 301.29045,
    y: 623.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(502.51397 1168.40466) rotate(180)",
    fill: "#b05ffd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M329.17019,582.17854a10.05577,10.05577,0,0,1-7.98-13.19378l-28.149-22.014,17.6029-5.91371,24.032,21.8115a10.11027,10.11027,0,0,1-5.506,19.31Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.79045,406.90466l-17.33506.36767a33.07345,33.07345,0,0,0-10.66494,24.63233v81.90945l65.04814,54.38381,21.03376-20.36807-48.416-52.74862Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 256.00448,
    y: 127.5727,
    width: 643.86166,
    height: 412.35761,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 274.41555,
    y: 179.29263,
    width: 607.03946,
    height: 336.24257,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 255.72954,
    y: 127.20769,
    width: 643.86163,
    height: 27.3536,
    fill: "#b05ffd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.05655,
    cy: 141.1923,
    r: 5.06978,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.30016,
    cy: 141.1923,
    r: 5.06979,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.54378,
    cy: 141.1923,
    r: 5.06979,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 512.47915,
    y: 214.18052,
    width: 129.9838,
    height: 73.34799,
    fill: "#b05ffd"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 512.47915,
    y: 307.95454,
    width: 129.9838,
    height: 78.91873,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 670.31658,
    y: 214.18052,
    width: 155.98053,
    height: 116.12476,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 670.31658,
    y: 364.52254,
    width: 155.98053,
    height: 116.12476,
    fill: "#b05ffd"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 330.31658,
    y: 214.18052,
    width: 155.98053,
    height: 116.12476,
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.208 79.642 576.774 246.796 578.81 247.337 622.827 81.748 621.208 79.642",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "749.464 421.592 705.447 587.182 707.066 589.288 751.5 422.133 749.464 421.592",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,485.052h-150a3.5,3.5,0,0,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,465.052h-150a3.5,3.5,0,0,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,505.052h-150a3.5,3.5,0,0,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,525.052h-150a3.5,3.5,0,1,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,545.052h-150a3.5,3.5,0,1,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M633.29045,565.052h-150a3.5,3.5,0,1,1,0-7h150a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M789.538,505.052h-124a3.5,3.5,0,0,1,0-7h124a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M789.538,525.052h-124a3.5,3.5,0,1,1,0-7h124a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M789.538,545.052h-124a3.5,3.5,0,1,1,0-7h124a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M789.538,565.052h-124a3.5,3.5,0,1,1,0-7h124a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.22352,
    cy: 46,
    r: 45,
    fill: "#f0f0f0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M774.29045,84.40466a46.24694,46.24694,0,0,0-6.91016.52c-1.16992.17-2.30957.38995-3.43994.66a45.97706,45.97706,0,0,0-19.48974,79.8c.77.65,1.5498,1.28,2.35986,1.88a45.99007,45.99007,0,1,0,27.48-82.86Zm0,90a43.74633,43.74633,0,0,1-26-8.53c-.81983-.6-1.60986-1.22-2.37988-1.88a43.974,43.974,0,0,1,19.62011-76.71c1.11963-.23,2.23975-.41,3.37989-.55a43.52969,43.52969,0,0,1,5.37988-.33,44,44,0,0,1,0,88Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 749.29045,
    y: 115.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1398.51397 152.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 749.29045,
    y: 127.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1398.51397 176.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 749.29045,
    y: 139.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1398.51397 200.40466) rotate(180)",
    fill: "#b05ffd"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.22352,
    cy: 628,
    r: 45,
    fill: "#f0f0f0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M850.29045,666.40466a46.24694,46.24694,0,0,0-6.91016.52c-1.16992.17-2.30957.38995-3.43994.66a45.97706,45.97706,0,0,0-19.48974,79.8c.77.65,1.5498,1.28,2.35986,1.88a45.99007,45.99007,0,1,0,27.48-82.86Zm0,90a43.74633,43.74633,0,0,1-26-8.53c-.81983-.6-1.60986-1.22-2.37988-1.88a43.974,43.974,0,0,1,19.62011-76.71c1.11963-.23,2.23975-.41,3.37989-.55a43.52969,43.52969,0,0,1,5.37988-.33,44,44,0,0,1,0,88Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 825.29045,
    y: 697.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1550.51397 1316.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 825.29045,
    y: 709.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1550.51397 1340.40466) rotate(-180)",
    fill: "#b05ffd"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 825.29045,
    y: 721.40466,
    width: 50,
    height: 6,
    rx: 3,
    transform: "translate(1550.51397 1364.40466) rotate(180)",
    fill: "#b05ffd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M497.55163,815.59534h-346.294a1.19069,1.19069,0,0,1,0-2.38137h346.294a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-150.06693 -84.40466)",
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignNotes);
export default __webpack_public_path__ + "static/media/design-notes.cfbcaef2989e5b105d62bcdb2b9fc758.svg";
export { ForwardRef as ReactComponent };